// extracted by mini-css-extract-plugin
export default {"root":"Iban_root__RaxTS"};